// extracted by css-extract-rspack-plugin
var _1 = "status-AFFECTED-aHHg6m";
var _2 = "status-NOT_AFFECTED-hErUAR";
var _3 = "status-UNDER_INVESTIGATION-yV4Msy";
var _4 = "status-UNKNOWN-kkgkcF";
var _5 = "status-AFFECTED-aHHg6m";
var _6 = "status-NOT_AFFECTED-hErUAR";
var _7 = "status-UNDER_INVESTIGATION-yV4Msy";
var _8 = "status-UNKNOWN-kkgkcF";
export { _1 as "status-AFFECTED", _2 as "status-NOT_AFFECTED", _3 as "status-UNDER_INVESTIGATION", _4 as "status-UNKNOWN", _5 as "statusAFFECTED", _6 as "statusNOT_AFFECTED", _7 as "statusUNDER_INVESTIGATION", _8 as "statusUNKNOWN" }
